<template>
	<span class="v-text" :style="{color,fontSize,backgroundColor}">
		<slot/>
	</span>
</template>

<script>
export default {
  props: {
    color: {
      default: ""
    },
    bgColor: {
      default: ""
    },
    fontSize: {
      default: ""
    }
  },
  computed: {
    backgroundColor() {
      return this.bgColor;
    }
  },
  mounted(){
    this.$bindEvents(this.$el);
  }
};
</script>

<style lang="less">
.v-text {
  &[bold] {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/text.vue